import * as z from "zod";

/** Guidelines of the draft version while one exists, else the published ones. */
export const getShopperAgentGuidelines = {
  name: "getShopperAgentGuidelines" as const,
  input: z.object({}),
  output: z.object({
    /** False while the feature flag is off for the team; the editor stays hidden. */
    enabled: z.boolean(),
    guidelines: z.array(
      z.object({ merchantText: z.string(), rule: z.string() }),
    ),
  }),
};
